import React from 'react';
import styled from '@emotion/styled';
import { Box, Flex } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import ErrorBoundary from '@shared/v2/components/ErrorBoundary';
import Pagination from '@shared/v2/components/Pagination';
import usePagination from '@shared/v2/hooks/usePagination';

import useScrollIntoView from '@/hooks/useScrollIntoView';
import Tile from '@/propTypes/Campaign';
import ProcuredOfferOption from '../ProcuredOfferOption';

const StyledBox = styled(Box)`
  scroll-margin-top: 110px; //Size of sticky origin bar
`;

const renderTile = (tile, index) => {
  const tiles = {
    CROSS_SELL_BANNER: null,
    FEATURED_PROPERTY: null,
    PROCURED_OFFER: (
      <StyledBox
        width="100%"
        key={tile.id}
        py={5}
        data-testid="PROPERTY_CARD"
        id={tile.id}
      >
        <ProcuredOfferOption tile={tile} index={index} showHotelTerms />
      </StyledBox>
    ),
  };

  return tiles[tile.type];
};

const ITEMS_PER_PAGE = 20;

const CardListing = ({ tiles }) => {
  const scrollIntoCardListing = useScrollIntoView(
    '#exclusive_offers_cards_list',
    0,
  );
  const { currentPageItems, currentPageNumber, numberOfPages, goTo } =
    usePagination(tiles, {
      pageSize: ITEMS_PER_PAGE,
    });

  const handleChangePaginationPage = (pageNum) => {
    goTo(pageNum);
    scrollIntoCardListing();
  };

  return (
    <ErrorBoundary>
      <Flex
        flexDirection={['column', null, 'row']}
        flexWrap="wrap"
        id="exclusive_offers_cards_list"
      >
        {currentPageItems.map((tile, index) => renderTile(tile, index))}
      </Flex>
      {tiles.length > ITEMS_PER_PAGE && (
        <Box my="7">
          <Pagination
            numPages={numberOfPages}
            page={currentPageNumber}
            onPageChange={handleChangePaginationPage}
            itemsPerPage={ITEMS_PER_PAGE}
            numItems={tiles.length}
            itemName="offers"
            showItemCount
          />
        </Box>
      )}
    </ErrorBoundary>
  );
};

CardListing.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.shape(Tile)).isRequired,
};

export default CardListing;
